import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class ExcelMaterialImport_ds_get_currencies_by_shortlabelService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { short_labels?: string[] }): 
  Promise<{ result: { Id?: number, ShortLabel?: string }[] }> 
  {
    let url = `${environment.backendUrl}api/ExcelMaterialImport/datasources/ds_get_currencies_by_shortlabel/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { short_labels?: string[], $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, ShortLabel?: string }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/ExcelMaterialImport/datasources/ds_get_currencies_by_shortlabel/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { short_labels?: string[], $keys: number[] }): 
  Promise<{ result: { Id?: number, ShortLabel?: string }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/ExcelMaterialImport/datasources/ds_get_currencies_by_shortlabel/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      short_labels?: string[]    }) {
      return false;
    }
}
